
import moment from "moment";
import noDataLabel from "../common/no-data-label.vue";
export default {
  components: { noDataLabel },
  data() {
    return {
      periods: [
        { value: "hour", label: "Hourly" },
        { value: "day", label: "Daily" }
      ],
      selectedPeriod: "",
      menu: false,
      series: [
        {
          name: "Orders",
          data: [25, 50, 75, 75, 70, 60, 25, 5, 5, 10, 10, 5, 20, 50]
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            // columnWidth: "20px",
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: false,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },

        xaxis: {
          labels: {},
          categories: [],
          position: "bottom",
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: false
          }
        },
        tooltip: {
          x: {
            show: true
          }
        }
      }
    };
  },
  computed: {
    getLabel() {
      return (
        this.periods.find((el) => el.value == this.selectedPeriod)?.label ||
        "Select period"
      );
    }
  },
  mounted() {
    this.selectedPeriod = this.periods[0].value;
  },
  methods: {
    fetchPeakHours() {}
  }
};
